var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "mt-3" }, [
      _c(
        "div",
        {
          staticClass: "chips-container",
          class: {
            "no-background": _vm.noBackground
          }
        },
        [
          _c("p", { staticClass: "bold mb-2" }, [
            _vm._v(" " + _vm._s(_vm.title) + " ")
          ]),
          _vm._l(_vm.selectedItems, function(item) {
            return _c(
              "div",
              {
                key: item[_vm.objectId],
                staticClass: "label label-default chips highlight",
                class: {
                  "with-title": _vm.itemHasTitle(item)
                }
              },
              [
                _vm.itemHasTitle(item)
                  ? _c("div", { staticClass: "chips-title" }, [
                      _vm._v(" " + _vm._s(item[_vm.objectTitle]) + " ")
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "inline",
                    class: {
                      "with-title": _vm.itemHasTitle(item)
                    }
                  },
                  [
                    item[_vm.objectSubTitle]
                      ? _c("b", [
                          _vm._v(" " + _vm._s(item[_vm.objectSubTitle]) + " ")
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(item[_vm.objectText]) + " ")
                  ]
                ),
                !_vm.disabled
                  ? _c("i", {
                      staticClass: "mt-1 ml-2 far fa-times-circle pointer",
                      class: { "with-title": _vm.itemHasTitle(item) },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.onItemDeleted(item)
                        }
                      }
                    })
                  : _vm._e()
              ]
            )
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }